import {
	isPageStatusFilterValueKey,
	PageStatusFilterValue,
} from '../../../../../common/constants/filters/page-status-filter';
import type { SelectFilterState } from '../../../../../common/constants/filters/select-filter/types';

export const generateQueryParamsGetState = <ID extends string>(
	initialState: SelectFilterState<ID>,
	queryParamKey: string,
) => {
	return (queryParams: Record<string, string[]>): SelectFilterState<ID> => {
		const queryParamValue = queryParams[queryParamKey];

		let value: string[] | undefined;

		if (Array.isArray(queryParamValue)) {
			if (queryParamValue[0] === 'all') {
				value = queryParamValue;
			} else if (isPageStatusFilterValueKey(queryParamValue[0])) {
				value = [PageStatusFilterValue[queryParamValue[0]]];
			}
		}

		return {
			...initialState,
			value: value || initialState.value,
		};
	};
};
